import BarChart from 'src/features/statistic/components/chart/BarChart';
import { DataKey, TransformedBarItem } from 'src/features/statistic/types';
import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import { SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock';
import { cn } from 'src/utils/shadcn';

type Props<T> = {
    dataKeys: DataKey[];
    data: TransformedBarItem[];
    title: string;
    isLoading: boolean;
    className?: string;
    colorMapping?: Record<string, string>;
    dynamicStats?: T[];
    getLabel?: (entry: T) => string;
};
export default function WidgetDurationBreakdown<T>({
    className,
    title,
    colorMapping,
    dynamicStats,
    getLabel,
    ...props
}: Props<T>) {
    return (
        <GeneralBlock className={cn('flex-1', className)}>
            <SectionBlockTitle>{title}</SectionBlockTitle>
            <BarChart {...props} colorMapping={colorMapping} dynamicStats={dynamicStats} getLabel={getLabel} />
        </GeneralBlock>
    );
}
